import { render, staticRenderFns } from "./InventoryAlarm.vue?vue&type=template&id=1de1ae2e&scoped=true"
import script from "./InventoryAlarm.vue?vue&type=script&lang=js"
export * from "./InventoryAlarm.vue?vue&type=script&lang=js"
import style0 from "./InventoryAlarm.vue?vue&type=style&index=0&id=1de1ae2e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1de1ae2e",
  null
  
)

export default component.exports